import { KYC_KRA_NAME } from "../types/client/client";

export const KYC_VALIDATION_LINKS: Record<KYC_KRA_NAME, string> = {
  karvykra: "https://www.karvykra.com/KYC_Validation/Default.aspx",
  ndmlkra: "https://kra.ndml.in/kra/web/v3/#/kyc/initiate",
  cvlkra: "https://validate.cvlindia.com/CVLKRAVerification_V1/",
  camskra: "https://camskra.com/emvalidation.aspx",
};

export const BOOK_DEMO_URL = "https://cal.com/creso-demo/30min";
